// @flow

const getConfiguration = (props: any) => {
    return {
        visible: true,
        // visible: (props.data && props.data.type && props.data.type === 'BASE'),
    };
}
export default getConfiguration;